module.exports = "<app-splash *ngIf=\"showInit\" (SelectGroupe)=\"onSelectGroupe($event)\"></app-splash>\r\n<app-creator *ngIf=\"! showInit\" [Configuration]=\"selectedGroupe\" (CancelConfiguration)=\"onCancelConfiguration()\" ></app-creator>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 302
// module chunks = 1